import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import CircularProgress from "@mui/material/CircularProgress";
import BackRight from "assets/images/backRight.png";
import "./index.scss";


function formatDateTime(isoDateString) {
    const date = new Date(isoDateString);

    const dateOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    };

    const timeOptions = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
    };

    const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(date);
    const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);

    return `${formattedDate}, ${formattedTime}`;
}
const fixedTemploValue = (i) => i > 0 ? `00${Math.floor(i)}`.slice(-3) : '-';


const DraftInfo = ({ data, onOpen, onBack, loading }) => {
    return (
        <Box className="draft-info-wrapper">
            <Box className="top-box">
                <Box
                    className="parent-backSpace"
                    onClick={onBack}
                >
                    <img src={BackRight} alt="backSpace" />
                </Box>
                <span>{data?.name ? data.name : `نامشخص`}</span>
            </Box>
            <List className="details">
                <ListItem className="item-detail">
                    <Box className="title">
                        Length
                    </Box>
                    <Box className="value">
                        {Math.round(data.length * 100) / 100} s
                    </Box>
                </ListItem>        
                <ListItem className="item-detail">
                    <Box className="title">
                        Created
                    </Box>
                    <Box className="value">
                        {formatDateTime(data.created)}
                    </Box>
                </ListItem>
                <ListItem className="item-detail">
                    <Box className="title">
                        Modified
                    </Box>
                    <Box className="value">
                        {formatDateTime(data.modified)}
                    </Box>
                </ListItem>
                <ListItem className="item-detail">
                    <Box className="title">
                        Tempo
                    </Box>
                    <Box className="value">
                        {fixedTemploValue(data.tempo)}
                    </Box>
                </ListItem>
            </List>
            <Box className="actions">
                <button onClick={onOpen} disabled={loading}>
                    {loading ? <CircularProgress size={30} color="inherit" /> : 'Open'}
                </button>
            </Box>
        </Box>
    )
}

export default DraftInfo;